import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { deepCopy, each } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import styles from '../index.module.less';
import { Col, Form, Row } from 'antd';
import { getCityList, changeCitiesWithEN } from '../../../config-v2';
import V2Title from '../../../Feedback/V2Title';
import V2Form from '../../../Form/V2Form';
import V2FormSelect from '../../../Form/V2FormSelect/V2FormSelect';
import V2Container from '../../V2Container';

const V2KeyInCity: React.FC<any> = forwardRef(({
  valueKey,
  setOpen,
  setCheckedValue,
  extraCities,
  onConfirm,
  allowSpecialRegion,
  onDataLoaded,
  beforeCheck,
  refactorOriginData,
}, ref) => {
  const dispatch = useDispatch();
  const cities = useSelector((state: any) => state.common.citiesWithEN) || [];
  const contentRef: any = useRef(null);
  const [form] = Form.useForm();
  const [mainHeight, setMainHeight] = useState<number>(0);
  const [groups, setGroups] = useState<any[]>([]);
  const [list, setList] = useState<any[]>([]);
  const [activeKey, setActiveKey] = useState<string | number>();
  const [newValue, setNewValue] = useState<any>({});
  const methods = useMethods({
    getSelections(list: any[]) {
      const cityMap: any = {};
      const groups: any[] = [];
      const _list = deepCopy(list).map((item: any) => {
        if (['台北', '香港', '澳门'].some((region) => item.name.indexOf(region) !== -1)) {
          item.children?.forEach(city => {
            city.disabled = !allowSpecialRegion;
          });
          return {
            ...item,
            disabled: !allowSpecialRegion
          };
        }
        return item;
      });
      _list.forEach((item: any) => {
        if (item.name.trim()) {
          const key = item.enName.slice(0, 1).toUpperCase();
          if (!cityMap[key]) {
            cityMap[key] = [];
          }
          cityMap[key].push(item);
        }
      });

      each(cityMap, (children: any, key: string) => {
        groups.push({
          index: key,
          title: key,
          children
        });
      });
      groups.sort((a, b) => a.index.toLowerCase().localeCompare(b.index.toLowerCase()));
      unstable_batchedUpdates(() => {
        const lastGroups = refactorOriginData?.refactorGroups ? refactorOriginData?.refactorGroups(groups) : groups;
        const lastList = refactorOriginData?.refactorList ? refactorOriginData?.refactorList(_list) : _list;
        setGroups(lastGroups);
        setList(lastList);
        onDataLoaded && onDataLoaded(lastList);
      });
    },
    async getCities() {
      const cityResult = await getCityList();
      dispatch(changeCitiesWithEN(cityResult));
      methods.getSelections(cityResult);
    },
    onKeyClick(key) {
      setActiveKey(key);
      const parent = contentRef.current;
      const child: any = document.getElementsByClassName(`v2CityItemPY-${key}`)[0];
      const parentTop = parent.getBoundingClientRect().top;
      const childTop = child.getBoundingClientRect().top;
      parent.scrollTop = childTop - parentTop + parent.scrollTop;
    },
    onChecked(item) {
      if (!item.disabled) {
        methods.updateRes(item);
      }
    },
    onSearch(_, item) {
      setTimeout(() => {
        methods.updateRes(item);
      }, 200);
    },
    async updateRes(item) {
      if (beforeCheck) {
        const stop = await beforeCheck(item);
        if (stop) {
          return;
        }
      }
      setOpen(false);
      setCheckedValue(item);
      onConfirm?.(item);
    }
  });
  useEffect(() => {
    // 如果不存在则进行请求
    if (!cities.length) {
      methods.getCities();
    } else {
      methods.getSelections(cities);
    }
  }, []);
  useImperativeHandle(ref, () => ({
    init(checkedValue) {
      setActiveKey(undefined);
      form.setFieldValue('searchCity', undefined);
      setNewValue(checkedValue);
      if (contentRef.current) {
        setTimeout(() => {
          contentRef.current.scrollTop = 0;
        }, 0);
      }
    }
  }));
  return (
    <V2Container
      className={cs([styles.v2CitySearch, styles.v2CitySearchType2, 'v2CitySearch'])}
      style={{ height: `calc(100vh - 266px)` }}
      emitMainHeight={(h) => setMainHeight(h)} // 再生成一个新的高度，给table使用
      extraContent={{
        top: <>
          <V2Form form={form}>
            <V2FormSelect
              placeholder='搜索城市'
              name='searchCity'
              options={list}
              config={{ showSearch: true, fieldNames: { label: 'name', value: valueKey }, allowClear: false }}
              onChange={methods.onSearch}
            />
          </V2Form>
          {
            extraCities?.map((extra, index) => {
              return (
                <div key={index}>
                  <V2Title className={cs(styles.v2CityIndexBarTitle, 'v2CityIndexBarTitle')} type='H3' text={extra.title} extra={extra.extra}/>
                  <Row className={cs(styles.v2CityIndexBarRow, 'v2CityIndexBarRow')} gutter={[8, 8]}>
                    {
                      extra.cities.map((item, key) => {
                        return (
                          <Col
                            span={4}
                            key={key}
                            className={cs(styles.v2CityIndexBarCol, 'v2CityIndexBarCol')}
                            onClick={() => methods.onChecked(item)}
                          >
                            <div className={cs([
                              styles.v2CityIndexBarItem,
                              'v2CityIndexBarItem',
                              newValue.id === item.id && styles.active
                            ])}
                            >
                              {item.name}
                            </div>
                          </Col>
                        );
                      })
                    }
                  </Row>
                </div>
              );
            })
          }
          <V2Title className={cs(styles.v2CityIndexBarTitle, 'v2CityIndexBarTitle')} type='H3' text='按字母选择'/>
          <div className={cs(styles.v2EnNameList, 'v2EnNameList')}>
            {
              groups.map(item => {
                return (<div
                  key={item.index}
                  className={cs([
                    styles.v2EnNameItem,
                    'v2EnNameItem',
                    activeKey === item.index && styles.active
                  ])}
                  onClick={() => methods.onKeyClick(item.index)}
                >{item.title}</div>);
              })
            }
          </div>
        </>,
      }}
    >
      <div ref={contentRef} className={cs(styles.v2CityContent, 'v2CityContent')} style={{ maxHeight: mainHeight }}>
        {
          groups.map(item => {
            return (
              <div
                className={cs([
                  styles.v2CityItem,
                  'v2CityItem',
                  activeKey === item.index && styles.active,
                  `v2CityItemPY-${item.index}`
                ])}
                key={item.index}
              >
                <div className={cs(styles.v2CityItemKey, 'v2CityItemKey')}>
                  <div className={cs(styles.v2CityItemKeyInner, 'v2CityItemKeyInner')}>
                    <div className={cs(styles.v2CityItemKeyCover, 'v2CityItemKeyCover')}>
                      {item.title}
                    </div>
                    <div className={cs(styles.v2CityItemKeyCover2, 'v2CityItemKeyCover2')}></div>
                  </div>
                </div>
                <div className={cs(styles.v2CityItemMain, 'v2CityItemMain')}>
                  <div className={cs(styles.v2CityItemMainRight, 'v2CityItemMainRight')}>
                    <div className={cs(styles.v2CityItemRightCities, 'v2CityItemRightCities')}>
                      {
                        item.children.map(city => {
                          return (
                            <div
                              key={city.id}
                              className={cs([
                                styles.v2CityItemRightCity,
                                city.disabled && styles.disabled,
                                'v2CityItemRightCity',
                                newValue.id === city.id && styles.active
                              ])}
                              onClick={() => methods.onChecked(city)}
                            >
                              {city.name}
                            </div>
                          );
                        })
                      }
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        }
      </div>
    </V2Container>
  );
});

export default V2KeyInCity;
